var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v6H0v-6Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19h30v6H0v-6Z",
    style: {
      fill: "#060"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.428,20.938l.217.125,5.839-10.114c.342-.091.529-.416.717-.741.125-.216.625-1.083.842-2.208-.866.75-1.366,1.616-1.491,1.833-.188.325-.375.65-.283.991l-5.841,10.114Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667,21.148l-.325-.188,5.858-10.146c-.083-.357.11-.69.296-1.013.521-.902,1.106-1.503,1.504-1.849l.136-.118-.034.177c-.1.518-.328,1.325-.849,2.227-.186.323-.379.656-.729.763l-5.857,10.147ZM11.513,20.915l.108.062,5.821-10.082.025-.007c.317-.085.492-.389.679-.712.454-.786.681-1.497.796-2.003-.381.352-.883.905-1.337,1.691-.186.323-.362.627-.277.944l.007.025-.013.022-5.809,10.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M11.428,20.938l.217.125,5.839-10.114c.342-.091.529-.416.717-.741.125-.216.625-1.083.842-2.208-.866.75-1.366,1.616-1.491,1.833-.188.325-.375.65-.283.991l-5.841,10.114Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M18.572,20.938l-.217.125-5.839-10.114c-.342-.091-.529-.416-.717-.741-.125-.216-.625-1.083-.842-2.208.866.75,1.366,1.616,1.491,1.833.188.325.375.65.283.991l5.841,10.114Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.333,21.148l-5.858-10.146c-.35-.107-.543-.44-.729-.763-.521-.902-.749-1.709-.849-2.227l-.034-.177.136.118c.399.345.983.947,1.504,1.849.186.323.379.656.296,1.013l5.858,10.146-.324.187ZM11.059,8.173c.114.506.342,1.217.796,2.003.186.323.362.627.679.712l.025.007.013.022,5.808,10.06.108-.062-5.821-10.082.007-.025c.085-.316-.091-.621-.277-.944-.455-.786-.957-1.339-1.338-1.691Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M18.572,20.938l-.217.125-5.839-10.114c-.342-.091-.529-.416-.717-.741-.125-.216-.625-1.083-.842-2.208.866.75,1.366,1.616,1.491,1.833.188.325.375.65.283.991l5.841,10.114Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12v6h12.625c.375,1,1.625,3,2.375,3s2-2,2.375-3h12.625v-6h-12.625c-.375-1-1.625-3-2.375-3s-2,2-2.375,3H0Z",
    style: {
      fill: "#b00"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M17.375,18c.375-1,.625-2,.625-3s-.25-2-.625-3c-.375,1-.625,2-.625,3s.25,2,.625,3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "c1",
    "data-name": "c",
    d: "M12.625,18c-.375-1-.625-2-.625-3s.25-2,.625-3c.375,1,.625,2,.625,3s-.25,2-.625,3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 15,
    rx: 0.5,
    ry: 0.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M15.125,15.731s.5,1,.5,2.625-.5,2.625-.5,2.625v-5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M14.875,14.269s-.5-1-.5-2.625.5-2.625.5-2.625v5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d2",
    "data-name": "d",
    d: "M14.875,15.731s-.5,1-.5,2.625.5,2.625.5,2.625v-5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3",
    "data-name": "d",
    d: "M15.125,14.269s.5-1,.5-2.625-.5-2.625-.5-2.625v5.25Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.5dc3397125b020bd901b60ce9bf379a0.svg";
export { ForwardRef as ReactComponent };